import goals from './goals';
import tasks from './tasks';
import mentee from './mentee';

export default {
  async getMyData(context) {
    const myMentees = await context.dispatch('getMyMentees', true);
    await context.dispatch('getMenteesRequests');

    // get chat data
    myMentees.forEach((myMentee) => {
      context.dispatch('getUserMessages', [
        myMentee.menteeid, // userId
        context.rootState.User.id, // mentorid
        myMentee.menteeid, // menteeid
      ]);
    });
  },
  ...goals,
  ...tasks,
  ...mentee,
};
